import { render, staticRenderFns } from "./MyEvents.vue?vue&type=template&id=1dc23a76&scoped=true&"
import script from "./MyEvents.vue?vue&type=script&lang=js&"
export * from "./MyEvents.vue?vue&type=script&lang=js&"
import style0 from "./MyEvents.vue?vue&type=style&index=0&id=1dc23a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc23a76",
  null
  
)

export default component.exports